// Active / Archived / All lifecycle tabs — the Song Library's tab strip
// (src/pages/songs.tsx ~1099-1129) factored out so every catalog surface
// exposes the same three views with the same live counts.

import React from 'react';
import { Nav } from 'react-bootstrap';
import type { CatalogLifecycleView } from './catalogLifecycleTypes';

/** Blank when the count is unknown, so a tab never renders "(0)" while loading. */
export function formatTabCount(n: number | undefined): string {
  if (n == null || n < 0) return '';
  return ` (${n.toLocaleString()})`;
}

interface CatalogLifecycleTabsProps {
  view: CatalogLifecycleView;
  onChange: (view: CatalogLifecycleView) => void;
  activeCount: number | undefined;
  archivedCount: number | undefined;
  testId?: string;
}

export function CatalogLifecycleTabs({
  view,
  onChange,
  activeCount,
  archivedCount,
  testId,
}: CatalogLifecycleTabsProps) {
  const allCount =
    activeCount != null && archivedCount != null && activeCount >= 0 && archivedCount >= 0
      ? activeCount + archivedCount
      : undefined;

  return (
    <Nav variant="tabs" className="mb-3" data-testid={testId}>
      <Nav.Item>
        <Nav.Link active={view === 'active'} onClick={() => onChange('active')}>
          Active{formatTabCount(activeCount)}
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link active={view === 'archived'} onClick={() => onChange('archived')}>
          Archived{formatTabCount(archivedCount)}
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link active={view === 'all'} onClick={() => onChange('all')}>
          All{formatTabCount(allCount)}
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
}
